import * as actionTypes from '../constants/idex';
import { updateObject } from '../../../../shared/utils';

const initialState = {
  file: null,
  fileError: null,
  fileLoading: false,
};

const getPdfFileStart = (state, action) => {
  return updateObject(state, {
    fileError: null,
    fileLoading: true,
  });
};

const getPdfFileSuccess = (state, action) => {
  return updateObject(state, {
    file: action.data,
    fileError: null,
    fileLoading: false,
  });
};

const getPdfFileFail = (state, action) => {
  return updateObject(state, {
    file: null,
    fileError: action.error,
    fileLoading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.COVER_PAGE_GET_PDF_FILE_START:
      return getPdfFileStart(state, action);
    case actionTypes.COVER_PAGE_GET_PDF_FILE_SUCCESS:
      return getPdfFileSuccess(state, action);
    case actionTypes.COVER_PAGE_GET_PDF_FILE_FAIL:
      return getPdfFileFail(state, action);

    default:
      return state;
  }
};

export default reducer;
